import Badge from "hardcover-ui/components/Badge";
import { generateFeaturedBookSeries } from "lib/bookUtils";
import { Link } from "@inertiajs/react";
import { BookSerializersBookByline } from "types/serializers";

export interface Props {
  book: BookSerializersBookByline;
  className?: string;
  link?: boolean;
}

function BookSeriesTagWrapper({
  href,
  message,
  className,
}: {
  href?: string;
  className: string;
  message: string;
}) {
  if (href) {
  return (
      <Link
        href={href}
        className={`${className} hover:bg-gray-300 hover:dark:bg-gray-700 rounded-lg`}
      >
        <Badge variant="secondary" size="sm" className="inline-block">
          {message}
        </Badge>
      </Link>
    );
  }

  return (
    <Badge
      variant="secondary"
      size="sm"
      className={`inline-block ${className}`}
    >
      {message}
    </Badge>
  );
}

export function BookSeriesTag({ book, link = false, className = "" }: Props) {
  if (!book.featuredSeries?.id) {
    return false;
  }


  const message = generateFeaturedBookSeries(book);
  const { featuredSeries } = book;
  return (
    <BookSeriesTagWrapper
      href={link ? `/series/${featuredSeries.series.slug}` : null}
      className={className}
      message={message}
    />
  );
}
